const Theme: any = {};

Theme.colors = {
  hotPink: '#FF71CE', // Vaporwave pink / bubblegum
  cyan: '#01CDFE', // Electric blue
  limeGreen: '#05FFA1', // Mint teal
  yellow: '#FFFB96', // Soft pastel yellow
  red: '#FF2D78', // Hot coral
  black: '#1e0b4a', // Medium purple (background)
  silver: '#E2D9F3', // Lavender white (text)
  purple: '#B967FF', // Ultra violet
  orange: '#FF9A00', // Sunset orange
  blue: '#2d0e6e', // Deep indigo
  neonGreen: '#05FFA1', // Mint
};

Theme.typography = {
  sansSerifFontFamily: '"Comic Sans MS", "Comic Sans", cursive, sans-serif',
  monospaceFontFamily: '"Courier New", monospace',
  fontSize: '1rem',
  fontWeight: '400',
  lineHeight: '1.5',
  color: Theme.colors.silver,
};

export { Theme };

export type ThemeType = typeof Theme;
